import { ChipPropsVariantOverrides } from "@mui/material";
import { DateTime } from "luxon";
import { AllDetectedMeeting } from "app/containers/TeamsTab/types";

export interface ICalendarEvent {
  id: string;
  aptTime: DateTime;
  aptName: string;
  aptState: keyof ChipPropsVariantOverrides;
  meetingId: number;
  webLink: string | null;
  userConfirmed: boolean;
  userAccountId: number | null;
}

export interface IData {
  id: string;
  aptDate: DateTime;
  events: ICalendarEvent[];
}

export function groupMeetingsByDate(
  meetings: AllDetectedMeeting[],
  userAccountIdByEmail: Record<string, number>,
  currentUserEmail: string | undefined
): IData[] {
  const groups = new Map<string, IData>();

  meetings
    .slice()
    .sort((a, b) => a.startTime.localeCompare(b.startTime))
    .forEach((meeting) => {
      const aptTime = DateTime.fromISO(meeting.startTime);
      const dayKey = aptTime.toISODate() ?? aptTime.toString();

      if (!groups.has(dayKey)) {
        groups.set(dayKey, {
          id: dayKey,
          aptDate: aptTime.startOf("day"),
          events: [],
        });
      }

      const otherParticipant = meeting.participants.find(
        (p) => p.email !== currentUserEmail
      ) ?? meeting.participants[0];
      const userAccountId = otherParticipant
        ? (userAccountIdByEmail[otherParticipant.email] ?? null)
        : null;

      groups.get(dayKey)?.events.push({
        id: String(meeting.id),
        aptTime,
        aptName: meeting.title,
        aptState: meeting.userConfirmed ? "success" : "warning",
        meetingId: meeting.id,
        webLink: meeting.webLink,
        userConfirmed: meeting.userConfirmed,
        userAccountId,
      });
    });

  return Array.from(groups.values());
}
